export const POST_IMAGE = "POST_IMAGE";
export const GET_IMAGES = "GET_IMAGES";
export const DELETE_IMAGE = "DELETE_IMAGE";